'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';

/**
 * Conditional reCAPTCHA loader
 * Only loads reCAPTCHA when needed (on form pages)
 * Saves ~346KB on non-form pages
 */
export default function ReCaptchaLoader() {
  const [siteKey, setSiteKey] = useState<string>('');

  useEffect(() => {
    // Get site key on client side only
    const key = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';
    setSiteKey(key);
  }, []);

  if (!siteKey) return null;

  return (
    <Script
      src={`https://www.google.com/recaptcha/api.js?render=${siteKey}`}
      strategy="afterInteractive"
    />
  );
}

